import { apiGet, apiPost } from './client';

export function getEmailSettings() {
  return apiGet('/email/settings');
}

export function saveEmailSettings(body) {
  return apiPost('/email/settings', body);
}

export function verifyEmail() {
  return apiPost('/email/verify', {});
}

export function getVerifyStatus() {
  return apiGet('/email/verify-status');
}

export function addRecipient(email) {
  return apiPost('/email/add-recipient', { email });
}

export function removeRecipient(email) {
  return apiPost('/email/remove-recipient', { email });
}

export function listRecipients() {
  return apiGet('/email/recipients');
}

export function sendTestEmail(to) {
  return apiPost('/email/test', { to });
}

export function updateEmail(emailId, updates) {
  return apiPost('/email/update', { emailId, ...updates });
}

export function sendEmail(emailId) {
  return apiPost('/email/send', { emailId });
}

export function listEmails(campaignId) {
  return apiGet(`/email/list${campaignId ? `?campaignId=${campaignId}` : ''}`);
}
